/* eslint-disable react-hooks/exhaustive-deps */
import { Suspense, lazy, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import 'animate.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import './assets/styles/styles.scss';

import AuthenticateUser from 'components/authentication/AuthenticateUser';
import Authentication from 'components/authentication/Authentication';
import LogoutModal from 'components/authentication/logoutmodal/LogoutModal';
import Unauthorized from 'components/authentication/unauthorized/Unauthorized';
import UnderMaintenance from 'components/authentication/undermaintenance/UnderMaintenance';
import ConfigurePriorityView from 'components/customer/configure-priority/ConfigurePriorityView';
import CustomerView from 'components/customer/view/CustomerView';
import ViewInsights from 'components/customer/view/ViewInsights';
import ViewList from 'components/customer/view/ViewList';
import Home from 'components/home/Home';
import Notification from 'components/home/Notification';
import SystemAlerts from 'components/home/SystemAlerts';
import TileLayout from 'components/home/views/TileLayout';
import ReportDashboard from 'components/report-dashboard/ReportDashboard';
import RoleSelection from 'components/role/RoleSelection';
import { Spinner } from 'components/shared/loader/Spinner';
import Trends from 'components/trends-v2/Trends';
import useDatadogRum from 'hooks/useDatadogRum';
import { isCookieExpired } from 'utils/token-expired';
const CustomerHierarchyView = lazy(
  () => import('components/customer/hierarchy/CustomerHierarchyView')
);
const App = () => {
  const auth = useSelector((state) => state?.Auth?.token);
  const { unixId } = useSelector((state) => state?.Auth?.userClaimObject);
  const { initializeDatadog } = useDatadogRum();

  const MINUTE_MS = 300000;

  useEffect(() => {
    const interval = setInterval(() => {
      isCookieExpired(unixId);
    }, MINUTE_MS);

    // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
    return () => clearInterval(interval);
  }, [MINUTE_MS]);

  useEffect(() => {
    initializeDatadog();
  }, []);

  return (
    <>
      <ToastContainer
        pauseOnFocusLoss={false}
        theme='colored'
        autoClose={5000}
        position='top-right'
      />

      <Authentication authToken={auth}>
        <Routes>
          <Route
            path='/notification'
            element={<Notification />}
          />
          <Route
            path='/'
            element={<Home />}
          />
          <Route
            path='home'
            element={<Home />}
          />
          <Route
            path='view/:type/:viewName'
            element={<TileLayout />}
          />
          <Route
            path='system-alerts'
            element={<SystemAlerts />}
          />

          <Route
            path='authenticate'
            element={<AuthenticateUser />}
          />

          <Route
            path='/reportDashboard'
            element={<ReportDashboard />}
          />
          <Route
            path='/trends'
            element={<Trends />}
          />
          <Route
            path='/customerView'
            element={<CustomerView />}>
            <Route
              path='list'
              element={<ViewList />}
            />
            <Route
              path='list/:companyName'
              element={<ViewInsights />}
            />
          </Route>
          <Route
            path='/customer-hierarchy'
            element={
              <Suspense fallback={<Spinner />}>
                <CustomerHierarchyView />
              </Suspense>
            }
          />
          <Route
            path='/configure-priority'
            element={<ConfigurePriorityView />}
          />
          <Route
            path='/logout'
            element={<LogoutModal />}
          />
          <Route
            path='/maintenance'
            element={<UnderMaintenance />}
          />
          <Route
            path='/unauthorized'
            element={<Unauthorized />}
          />
          <Route
            path='/roleSelection'
            element={<RoleSelection />}
          />
        </Routes>
      </Authentication>
    </>
  );
};

export default App;
